import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { ChartDateIntervalSelectorModule } from '@core/components/charts/chart-date-interval-selector/chart-date-interval-selector.module';
import { ChartDateIntervalSelectorMapperService } from '@core/components/charts/chart-date-interval-selector/services/chart-date-interval-selector.mapper.service';
import { FcHorizontalBarChartModule } from '@core/components/charts/fc-horizontal-bar-chart/fc-horizontal-bar-chart.module';
import { HorizontalBarChartModule } from '@core/components/charts/horizontal-bar/horizontal-bar.module';
import { LineChartModule } from '@core/components/charts/line/line.module';
import { PieChartModule } from '@core/components/charts/pie/pie.module';
import { VerticalBarChartModule } from '@core/components/charts/vertical-bar/vertical-bar.module';
import { DataVolumetryTableModule } from '@core/components/data-volumetry-table/data-volumetry-table.module';
import { FcDateInputModule } from '@core/components/fc-input/base/fc-date-input/fc-date-input.module';
import { FcCompaniesInputModule } from '@core/components/fc-input/search-many/fc-companies-input/fc-companies-input.module';
import { FcLocationGroupsInputModule } from '@core/components/fc-input/search-many/fc-location-groups-input/fc-location-groups-input.module';
import { FcLocationsInputModule } from '@core/components/fc-input/search-many/fc-locations-input/fc-locations-input.module';
import { FcMaintenanceTypesInputModule } from '@core/components/fc-input/search-many/fc-maintenance-types-input/fc-maintenance-types-input.module';
import { FcSegmentsInputModule } from '@core/components/fc-input/search-many/fc-segments-input/fc-segments-input.module';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { FuseSidebarModule, FuseWidgetModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { DateRangePickerModule } from '@syncfusion/ej2-angular-calendars';
import { FilterModule } from 'app/main/reports/components/filter/filters.module';
import { VolumetryService } from './api/queries.service';
import { FilterComponent } from './filter/filter.component';
import { VolumetryComponent } from './volumetry.component';

const routes: Routes = [
  {
    path: 'relatorios/volumetria',
    component: VolumetryComponent,
    canActivate: [AuthenticatedGuard],
    data: { title: 'CORE.SERVICES.NAVIGATION.REPORTS.VOLUMETRY' }
  }
];

@NgModule({
  declarations: [
    VolumetryComponent,
    FilterComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    TranslateModule,
    FuseSharedModule,
    FuseSidebarModule,
    FuseWidgetModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatTooltipModule,
    MatSelectModule,
    MatTableModule,
    MatPaginatorModule,
    MatMenuModule,
    MatSlideToggleModule,
    DataVolumetryTableModule,
    DateRangePickerModule,
    LineChartModule,
    FilterModule,
    FcDateInputModule,
    FcLocationsInputModule,
    FcMaintenanceTypesInputModule,
    FcSegmentsInputModule,
    FcLocationGroupsInputModule,
    FcCompaniesInputModule,
    HorizontalBarChartModule,
    VerticalBarChartModule,
    PieChartModule,
    FcHorizontalBarChartModule,
    ChartDateIntervalSelectorModule
  ],
  exports: [
    VolumetryComponent
  ],
  providers: [
    VolumetryService,
    ChartDateIntervalSelectorMapperService
  ]
})

export class VolumetryModule {}
